import {
  getCategoryColorClass,
  STATUS_CTA,
  CTA_LABEL_KEY,
  STATE_TO_BUCKET,
  STATUS_BUCKET,
} from '../constants';

/**
 * Maps a connected integration (from `integrationsService.listIntegrations`) to
 * the view model the Connected Integration Card renders (CT-4161). Only the
 * ACTIVE capability types are surfaced; status label/color/CTA come from the
 * Status System (CT-4195), never a local map.
 */
export const mapApiConnectedToUi = (item) => {
  const cta = STATUS_CTA[item.status] ?? null;
  const statusBucket = STATE_TO_BUCKET[item.status] ?? STATUS_BUCKET.DISCONNECTED;
  return {
    id: item.id,
    slug: item.slug,
    name: item.name,
    category: item.category,
    categoryColorClass: getCategoryColorClass(item.category),
    status: item.status,
    statusBucket,
    // Tooltip issue summary for non-working cards (CT-4199). Prefers the API
    // `status_summary` (mock/backend) and falls back to the status-keyed i18n.
    statusSummary: item.status_summary ?? null,
    statusSummaryKey: `integrations.attention.summary.${item.status}`,
    cta,
    ctaLabelKey: cta ? (CTA_LABEL_KEY[cta] ?? null) : null,
    activeCapabilities: (item.capabilities ?? []).filter((c) => c.active).map((c) => c.type),
    instancesCount: item.instances_count ?? 0,
    callsPerDay: item.calls_per_day ?? 0,
    usedInWorkflows: item.used_in_workflows ?? 0,
  };
};
